import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { LiveAgentRunPage } from "~/pages/LiveAgentRunPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/live-agents_/$id/runs/$runId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug, id, runId } = Route.useParams();
  useBreadCrumbs([
    { title: "Settings", link: `/${datasetSlug}/settings/api` },
    { title: "Live Agents", link: `/${datasetSlug}/settings/live-agents` },
    { title: "Runs", link: `/${datasetSlug}/settings/live-agents/${id}/runs` },
    { title: `Run ${runId.slice(0, 8)}`, link: `/${datasetSlug}/settings/live-agents/${id}/runs/${runId}` },
  ]);
  return <LiveAgentRunPage liveAgentId={id} runId={runId} />;
}
